import { Component, OnInit } from '@angular/core';
import 'lg-zoom.js';
import 'lg-share.js';
import 'lg-video.js';
import 'lg-pager.js';
import 'lg-autoplay.js';
import 'lg-fullscreen.js';
import 'lg-hash.js';
import 'lg-thumbnail.js';
declare var lightGallery: any;
@Component({
  selector: 'app-chess-championship-under-seven-seventeen',
  templateUrl: './chess-championship-under-seven-seventeen.component.html',
  styleUrls: ['./chess-championship-under-seven-seventeen.component.scss']
})
export class ChessChampionshipUnderSevenSeventeenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  ngAfterViewInit() {
    /*---------------------------
    :: lightBox Gallery
    -----------------------------*/

    let gall_image = document.getElementsByClassName('lightgallery');
    for (const gal of gall_image) {
      lightGallery(gal), {
        selector: 'a',
      }
    }

  }
}
